import { createSlice } from '@reduxjs/toolkit';
import { getLocalProvidersApi } from '../../../rtk-apis/hl7/getLocalProviders';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const getLocalProvidersSlice = createSlice({
  name: 'getLocalProviders',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getLocalProvidersApi.pending, state => {
        state.loading = true;
      })
      .addCase(getLocalProvidersApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || '';
      })
      .addCase(getLocalProvidersApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Failed to load providers';
      });
  },
});

export const { clearState: clearLocalProvidersState } = getLocalProvidersSlice.actions;
export default getLocalProvidersSlice.reducer;
